import { useMemo } from 'react'
import { PowerPerformanceForms } from '../../../types/mutual-fund-detail.types'
import { getConfigFromPowerForm } from '../utils'
import { LeftLeaf } from './LeftLeaf'
import { RightLeaf } from './RightLeaf'
import { ScoreValue } from './ScoreValue'

export const BigLeafRank = ({
  isElite,
  powerRank,
  categoryCount,
  powerForm
}: {
  isElite?: boolean
  powerRank: number | null
  categoryCount: number | null
  powerForm: `${PowerPerformanceForms}` | null
}) => {
  const colorsConfig = useMemo(() => {
    return getConfigFromPowerForm(powerForm || PowerPerformanceForms.IN_FORM)
  }, [powerForm])

  const denominator = categoryCount && categoryCount > 0 ? categoryCount : 0

  return (
    <div className='flex items-center'>
      <div className='mr-[-6px]' aria-hidden='true'>
        <LeftLeaf fill={colorsConfig.leafColor} />
      </div>
      <div style={{ color: colorsConfig.textColor }} className='text-sm'>
        <div className='text-[18px] font-[500] mx-[3px] mb-[3px] min-w-2 text-center'>
          <ScoreValue
            numerator={isElite && powerRank ? powerRank : null}
            denominator={denominator}
            isLock={!isElite}
            lockColor={colorsConfig.lockColor}
            textColor={colorsConfig.textColor}
            isInsideLeaf={true}
          />
        </div>
      </div>

      <div className='ml-[-6px] scale-[1.06]' aria-hidden='true'>
        <RightLeaf fill={colorsConfig.leafColor} />
      </div>
    </div>
  )
}
